import * as React from 'react';
import PropTypes from 'prop-types';
import Typography from '@mui/material/Typography';

function Title({ children, ...props }) {
    return (
        <Typography
            component="h2"
            variant="h6"
            color="primary"
            gutterBottom
            {...props}   // ✅ forward sx, className, style, etc.
        >
            {children}
        </Typography>
    );
}

Title.propTypes = {
    children: PropTypes.node,
};

export default Title;
